var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsInt, IsOptional, IsUUID, Min } from 'class-validator';
export class TreatmentConstraintDto {
    treatmentId;
    defaultDuration;
    appointmentCount;
    combinedTreatmentIds;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], TreatmentConstraintDto.prototype, "treatmentId", void 0);
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], TreatmentConstraintDto.prototype, "defaultDuration", void 0);
__decorate([
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], TreatmentConstraintDto.prototype, "appointmentCount", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], TreatmentConstraintDto.prototype, "combinedTreatmentIds", void 0);
//# sourceMappingURL=treatment-constraint.dto.js.map